import { useEffect, useState } from "react";
import { useClerk } from "@clerk/react";
import { Clock3, XCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { Wordmark } from "@/components/Wordmark";
import { Button } from "@/components/ui/button";

export default function PendingAccess({ status }) {
  const { signOut } = useClerk();
  const { refresh } = useMe();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/access/status").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  const declined = (info?.status || status) === "declined";
  const check = async () => {
    setBusy(true);
    try { await refresh(); } catch { toast("Still being reviewed"); } finally { setBusy(false); }
  };
  const Icon = declined ? XCircle : Clock3;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-5 py-12 text-center" data-testid="pending-access-page">
      <Wordmark />
      <div className="surface max-w-md space-y-3 p-6">
        <Icon size={30} className={`mx-auto ${declined ? "text-rose-600" : "text-amber-600"}`} />
        <h1 className="font-serif text-3xl" data-testid="pending-access-title">{declined ? "Your account is paused" : "We're checking your account"}</h1>
        <p className="text-sm text-slate-600" data-testid="pending-access-text">{declined
          ? "We reviewed this account and couldn't confirm it belongs to a real person, so it stays paused."
          : `Sorry${info?.name ? `, ${info.name}` : ""}. Some activity on this account looked automated, so we've paused it to keep Middle free of bots. A site administrator will check it soon and we'll email you${info?.email ? ` at ${info.email}` : ""} once you're back.`}</p>
        <div className="flex flex-wrap justify-center gap-2 pt-2">
          {!declined && <Button className="rounded-full" disabled={busy} onClick={check} data-testid="pending-check-btn">{busy ? "Checking…" : "Check again"}</Button>}
          <Button variant="outline" className="rounded-full" onClick={() => signOut({ redirectUrl: "/sign-in" })} data-testid="pending-signout-btn">Sign out</Button>
        </div>
      </div>
    </div>
  );
}
